import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

// Components
import DynamicCard from '../../../new-components/cards/DynamicCard';
import Slider from '../../../new-components/Slider';

// Helpers
import { getImagePath } from '../../../helpers/common';
import { handleCardClickEvent } from '../../../helpers/cards';
import { CardClickEventData } from '../../../new-lib/types/common';

// Types
import { Phase } from '../../../new-lib/types/entity';

interface CompoundSliderProps {
  entityCompounds: Phase[];
  sliderLocation: string;
  imageSize?: 'default' | 'vLow' | 'low' | 'medium' | 'high';
}
const CompoundSlider = ({
  entityCompounds,
  sliderLocation,
  imageSize
}: CompoundSliderProps) => {
  const { t } = useTranslation(['entity', 'common']);
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const getItemProps = (item: Phase, index: number) => {
    return {
      index: index,
      width: '100%',
      height: '100%',
      image: getImagePath(item.imageUrl),
      background: '#E4EBF2',
      imageLayerData: {
        header: item.name,
        subHeader:
          (item.propertiesCount || 0) + ' ' + t('properties', { ns: 'common' })
      },
      borderradius: '8px',
      linkTo: `/compound/${item.slug}`,
      onClick: () => {
        handleCompoundClickEvent(item, index);
      }
    };
  };

  const handleCompoundClickEvent = (item: Phase, index: number) => {
    const clickEventData: CardClickEventData = {
      compound: item,
      eventAction: 'cmpnd_click',
      eventLocation: sliderLocation,
      recommended: false,
      index: index,
      featureName: 'compound'
    };
    handleCardClickEvent(clickEventData);
  };

  const getSliderChildren = (items: Phase[]) => {
    return items.map((item, index: number) => {
      const itemProps = getItemProps(item, index);
      return (
        <DynamicCard
          key={itemProps.index}
          {...itemProps}
          imageSize={imageSize}
        />
      );
    });
  };

  const compoundsSliderProps = {
    slidesPerView: 'auto' as 'auto',
    spaceBetweenSlides: 8,
    slidesPerGroup: 1,
    children: getSliderChildren(entityCompounds),
    width: '200px',
    height: '200px'
  };

  return (
    <Container>
      <div className="headline-3 entity-title">{t('sub_compounds')}</div>
      {!isMobile && (
        <span className="results-available headline-subtitle">
          {entityCompounds.length} {t('results_available')}
        </span>
      )}
      <Slider {...compoundsSliderProps} />
    </Container>
  );
};
const Container = styled.div`
  margin-top: 32px;

  div.headline-3 {
    margin-bottom: 8px;
  }

  .image-layer-content {
    .header {
      font-size: ${props => props.theme.font.sizes.m};
    }

    .subHeader {
      font-size: ${props => props.theme.font.sizes.s};
    }
  }

  @media (max-width: ${props => props.theme.breakPoints.tablet.max}) {
    div.headline-3 {
      font-size: ${props => props.theme.font.sizes.l};

      span {
        font-size: ${props => props.theme.font.sizes.xs};
      }
    }
  }

  .results-available {
    display: block;
    margin-bottom: 16px;

    .entity-title {
      margin-bottom: 8px;
    }
  }
`;

export default CompoundSlider;
